import logger from "logging/logger";
import { useAppDispatch } from "store/hooks";
import {
  getEventByCode,
  getEventFromToken,
  getEventMemberStatus,
} from "services/apiService/apis";
import { addEventDetails } from "../eventSlice";

const useEventDataHook = () => {
  const dispatch = useAppDispatch();

  /**
   * Get member status in the event
   * @param eventId String
   */
  const getEventMemberData = async (eventId: string) => {
    const resp = await getEventMemberStatus(eventId);

    if (resp.isSuccess) {
      // setEventMember(resp.data);

      return resp.data;
    }
    logger.warn(
      `[useRegisterToEvent][getEventMemberStatus] Could not get user in eventmember: ${eventId} message: ${resp.message}`,
    );

    return null;
  };

  const getEventDataByCode = async (code: string) => {
    const resp = await getEventByCode(code);

    if (resp.isSuccess && resp.event) {
      dispatch(addEventDetails(resp.event));

      return resp.event;
    }

    logger.error(
      `[getEventDataByCode] Not able to get event data: ${code}, err: ${resp.message}`,
    );

    return null;
  };

  const getEventDataByToken = async (token: string) => {
    const resp = await getEventFromToken({ inviteToken: token });

    if (resp.isSuccess && resp.event) {
      dispatch(addEventDetails(resp.event));

      return resp.event;
    }

    return null;
  };

  return {
    getEventDataByToken,
    getEventDataByCode,
    getEventMemberData,
  };
};

export default useEventDataHook;
